/**
 * Quill’s clipboard.matchText collapses / strips regular spaces when HTML is
 * loaded (see quill/modules/clipboard.js). It keeps U+00A0 (nbsp).
 *
 * Frontend CSS can still show multi-space HTML via white-space: pre-wrap, so
 * content looks fine on the site, then “disappears” when reopened in admin.
 *
 * Convert intentional plain spaces in text nodes so Quill round-trips them.
 * Leaves existing &nbsp; entities and single mid-sentence spaces alone.
 */
export function preserveWhitespaceForQuill(html) {
  if (html == null) return "";
  if (typeof html !== "string") return String(html);
  if (!html) return "";

  return html.replace(/(^|>)([^<]*)(<|$)/g, (full, open, text, close) => {
    if (!text || !/[ \t]/.test(text)) return full;

    let next = text;

    // Tabs → four non-breaking spaces
    next = next.replace(/\t/g, "\u00a0\u00a0\u00a0\u00a0");

    // Runs of 2+ regular spaces → nbsps (Quill will not collapse these)
    next = next.replace(/ {2,}/g, (run) => "\u00a0".repeat(run.length));

    // Single leading/trailing spaces are also stripped by Quill — protect them
    next = next.replace(/^ /g, "\u00a0");
    next = next.replace(/ $/g, "\u00a0");

    return `${open}${next}${close}`;
  });
}

export default preserveWhitespaceForQuill;
